import lazyPage from "../../../../../../common/helpers/lazyPage";

export default lazyPage(
    "src/front/components/Task/types/RhytKnock/editor/rhytknockeditor.tsx",
    () => import("./rhytknockeditor"),
);
